/**
 * Applies credit term markup to a single price.
 * @param {number} originalPrice - The original price to apply markup to.
 * @param {number} creditTermValue - The credit term percentage value.
 * @returns {number} The price with markup applied.
 */
export function applyCreditTermMarkup(
  originalPrice: number,
  creditTermValue: number,
): number {
  if (
    !originalPrice ||
    originalPrice <= 0 ||
    !creditTermValue ||
    creditTermValue <= 0
  ) {
    return originalPrice;
  }

  const markupAmount = (originalPrice * creditTermValue) / 100;
  return Number((originalPrice + markupAmount).toFixed(2)); // Ensure the result is a number with 2 decimal places
}
